import { SymbolType } from '@op/constants/chart';
import { ByTypeSelectType, MentionsSentimentTabType } from '../../../constants';
import {
  dauIconList,
  mixedRating,
  pcuIconList,
  richImgMapFunc,
  SentimentMentionsTwoLevelType,
  starIconList,
  steamPositiveNegative,
} from '../utils';
import { gameInfoType } from '@op/types/common';
import { IHighPriorityEventItem } from '@op/components/ChartsEvents/types';
import { AnalysisSummaryTypeTab } from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/types';
import type { IEventTypeFilter, IEventDetailWithRegion } from '../EventDetailSidebar/types';

export type ChartPropsType = {
  tab: MentionsSentimentTabType | AnalysisSummaryTypeTab;
  gameInfo: gameInfoType;
  by_type: ByTypeSelectType;
  metrics: SentimentMentionsTwoLevelType | SentimentMentionsTwoLevelType[];
  hideMetricsSelect: boolean;
  type: SymbolType;
  filter: any;
  data: any;
  rightTitle: any;
  isRatingRatio?: boolean;
  eventData?: {
    eventList: any; // 选择器渲染的数据
    chartRenderEventList: any; // 渲染图表event的数据
    format: string; // 格式化的时间格式
    isEmpty: boolean;
  };
  chartEventSetting: {
    bubbleEvent?: { [key: string]: Array<any> };
    showEventAxis: boolean;
    showEventBubbles: boolean;
  };
  leftTitle?: any;
  tooltipConfig?: any;
  height?: number;
  handleEventClick?: (event: IHighPriorityEventItem) => void;
  sidebarVisible?: boolean;
  highPriorityEvents?: {
    [xAxisValue: string]: Array<IHighPriorityEventItem>;
  };
  /** 柱子点击回调（新增） */
  onBarClick?: (time: string) => void;
  /** 事件类型筛选（新增） */
  eventTypeFilter?: IEventTypeFilter;
  /** 高优先级事件块标题（多语言） */
  blockTitle?: Record<'zh-CN' | 'en-US', string>;
  /** 高优先级事件趋势文案（多语言，按趋势方向配置） */
  trendText?: Partial<Record<'up' | 'down' | 'mixed', Record<'zh-CN' | 'en-US', string>>>;
  /** 是否有高优先级事件 */
  HasHightEvent?:boolean;
  /** hover 事件气泡时预请求事件详情数据（预热缓存） */
  onBubbleHoverFetch?: (event: IHighPriorityEventItem) => void;
  /** hover 预览数据（用于 Bubble 展示） */
  hoverEventDetails?: IEventDetailWithRegion[];
  hoverLoading?: boolean;
};

export function getLegendFormat(formatMessage: any, options?: any) {
  const { byType } = options || {};
  return (params: any) => {
    if (starIconList.includes(params)) {
      let legendIcon = '';
      const count = parseInt(params);
      for (let index = 0; index < count; index++) {
        legendIcon += `{star|}`;
      }
      return legendIcon;
    }

    const text = formatMessage({ id: params });
    if (pcuIconList.includes(params)) return `{pcu|}${text}`;

    if (dauIconList.includes(params)) return `{dau|}${text}`;

    if (['by_rating', 'by_rating_ratio']?.includes(byType)) { 
      if (steamPositiveNegative.includes(params)) {
        if (params?.toLowerCase()?.includes('positive')) {
          return `{positive|} ${text}`;
        }
        return `{negative|} ${text}`;
      }

      if (mixedRating.includes(params)) {
        return `{mixed|} ${text}`;
      }
    }

    return text;
  };
}

export const chartIconRich = richImgMapFunc();
